"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _get = _interopRequireDefault(require("lodash/get"));
var _EnableInterestLendingModalComponent = _interopRequireDefault(require("./EnableInterestLendingModalComponent"));
var _modalActions = require("../../../../../redux/actions/modalActions");
var _modalDecorator = _interopRequireDefault(require("../../../../../hocs/modalDecorator"));
var _interestAccountActions = require("../../../../../redux/actions/interestAccountActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var form = 'interestAccounts';
var mapStateToProps = function mapStateToProps(state) {
  var formObj = state.form.interestAccounts;
  var buttonIsDisabled = !(0, _get["default"])(formObj, 'values.terms');
  return {
    buttonIsDisabled: buttonIsDisabled,
    showPhone: (0, _get["default"])(formObj, 'values.showPhone', false)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetForm: function resetForm() {
      return dispatch((0, _reduxForm.reset)(form));
    },
    submitForm: function submitForm() {
      dispatch((0, _interestAccountActions.createInterestAccountRequest)()).then(function (res) {
        if (res) {
          dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.INTEREST_ACCOUNTS_CONFIRMATION));
        }
      });
    }
  };
};
var connected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EnableInterestLendingModalComponent["default"]);
var wrapped = (0, _reduxForm.reduxForm)({
  form: form,
  onSubmit: function onSubmit() {}
})(connected);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: 'INTEREST_LENDING_ENABLE'
})(wrapped);